// src/index.js

import React from 'react';
import {createRoot} from "react-dom/client";
import './index.css';
import App from './App';
import { ConfigProvider } from 'antd';
import 'antd/dist/antd';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <ConfigProvider>
    <App />
  </ConfigProvider>,
);